import { UserManagerSettings } from "oidc-client-ts";

// export const oiauth: UserManagerSettings = {
//     authority: "http://localhost:8080/realms/futurecare/",
//     client_id: "hubio",
//     redirect_uri: "https://localhost:3000/signin-callback",
//     post_logout_redirect_uri: "https://localhost:3000/login",
//     client_secret: "vNOPiYnAtZl3U339EBLSj1cTeyEmAtuv",
//     response_type: "code",
//     scope: "openid profile salud"
// }

//If you're working on localhost change drprox.hub-io.org for localhost and remove "s" from https

export const oiauth: UserManagerSettings = {
    authority: "https://sso2.doctorprox.com:6040/realms/futurecare/",
    client_id: "fc-opsystem",
    redirect_uri: `${window.location.origin}/signin-callback`,
    post_logout_redirect_uri: `${window.location.origin}/signout-callback`,
    client_secret: "LMWGjaRRkjZDt1egq6xJzTkF9ChYacR9",
    response_type: "code",
    scope: "openid profile dr"
}
